import { FigureCard, FigureNote, Notes, money } from "./IntlBits";

const FLAG = { UK: "United Kingdom · pounds", US: "United States · dollars" };

export function GraduatePanel({ g, sources }) {
  return (
    <div data-testid="sci-intl-graduate">
      {["UK", "US"].map((c) => (
        <div key={c} className="mb-10" data-testid={`sci-intl-graduate-${c.toLowerCase()}`}>
          <h3 className="mb-4 font-mono text-xs uppercase tracking-wider text-stone-500">{FLAG[c]}</h3>
          <div className={`grid gap-4 md:grid-cols-2 ${g[c].length > 2 ? "lg:grid-cols-3" : ""}`}>
            {g[c].map((f) => <FigureCard key={f.id} f={f} testId={`sci-intl-fig-${f.id}`} />)}
          </div>
          <Notes testId={`sci-intl-graduate-${c.toLowerCase()}-notes`}>
            <ul className="space-y-1.5">{g[c].map((f) => <FigureNote key={f.id} f={f} sources={sources} showNotes={c === "UK"} testId={`sci-intl-fig-${f.id}-source`} />)}</ul>
            {c === "UK" && g.uk_previous?.length > 0 && (
              <div data-testid="sci-intl-graduate-uk-previous">
                <p className="font-medium text-stone-800">Previously shown here (withdrawn after the 16 Oct 2026 audit):</p>
                <ul className="list-disc pl-5">{g.uk_previous.map((p) => <li key={p.measure}>{p.label}: {money(p.value, "GBP")}. {p.basis}.</li>)}</ul>
              </div>
            )}
          </Notes>
        </div>
      ))}
      <div data-testid="sci-intl-cross-country-warning" className="rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
        <p className="font-medium">Don't compare the UK and US figures directly</p>
        <ul className="mt-1 list-disc pl-5 text-xs">
          {g.cross_country_warning.map((w) => <li key={w}>{w}</li>)}
        </ul>
      </div>
    </div>
  );
}
